import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core'
import { toObservable, toSignal } from '@angular/core/rxjs-interop'
import { interval, map, startWith, switchMap, tap } from 'rxjs'
import { NzModalModule } from 'ng-zorro-antd/modal'
import { NzIconModule } from 'ng-zorro-antd/icon'

@Component({
  selector: 'aiomed-notify-before-restart',
  imports: [NzModalModule, NzIconModule],
  templateUrl: './notify-before-restart.component.html',
  styleUrl: './notify-before-restart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotifyBeforeRestartComponent {
  readonly delayRestart = output<void>()
  readonly restartNow = output<void>()
  readonly secondsBeforeRestart = input.required<number>()
  readonly isVisible = input.required<boolean>()

  protected readonly secondsBeforeRestartObs$ = toObservable(
    this.secondsBeforeRestart
  )

  readonly tickingInterval = toSignal(
    this.secondsBeforeRestartObs$.pipe(
      switchMap(secondsBeforeRestart => {
        return interval(1000).pipe(
          map(value => {
            const difference = secondsBeforeRestart - value
            if (difference <= 0) {
              return 0
            }
            return difference
          }),
          tap(value => {
            if (value === 0) {
              this.restartNow.emit()
            }
          }),
          startWith(secondsBeforeRestart)
        )
      })
    )
  )
}
